<!-- Category driver -->
@if (
  data && (!data.isChild || (data.isChild && data.subCategory)) && data.primarySettingsOverride
) {
  <div class="forecast-table-grid-select-container" [attr.auto-qa]="autoTestAttribute">
    <ng-select
      [searchable]="false"
      [clearable]="true"
      [appendTo]="'body'"
      [ngModel]="data.driver"
      [items]="componentParent.driverService.DriverOptions"
      bindLabel="label"
      bindValue="value"
      [placeholder]="componentParent.checkService.formControlConstants.PLACEHOLDER.SELECT"
      [disabled]="
        !data.primarySettingsOverride ||
        disableDriver ||
        componentParent.isForecastFinalized ||
        componentParent.isClosedMonthsProcessing
      "
      [auxTooltip]="
        componentParent.checkService.tooltipText(
          componentParent.isForecastFinalized || componentParent.isClosedMonthsProcessing,
          componentParent.userHasModifyPermissions
        )
      "
      [ngClass]="{
        'forecast-table-grid-select forecast-driver-select': true,
        'is-invalid':
          (componentParent.checkService.isShowError(data.primarySettingsId) | async) ||
          (componentParent.checkService.isCategoryUnforecasted(data.primarySettingsId) | async),
      }"
      (ngModelChange)="
        componentParent.onDriverChange($event, data.fullCategory!.primary_settings, {
          name: 'category',
          id: data.id,
        })
      "
    >
      <ng-template ng-option-tmp let-item="item">
        @if (
          {
            optionNotAvailable: (mapOptionAvailable.get(item.value) | async) === false,
          };
          as obj
        ) {
          <div
            [auxTooltip]="obj.optionNotAvailable ? getOptionAvailableTooltip(item.value) : ''"
            class="px-[10px] py-[8px]"
            [ngClass]="{
              'cursor-not-allowed opacity-60': obj.optionNotAvailable,
            }"
            (click)="obj.optionNotAvailable && $event.stopPropagation()"
          >
            <span [title]="item.label">{{ item.label }}</span>
          </div>
        }
      </ng-template>
    </ng-select>
  </div>
}

<!-- Activity driver -->
@if (
  data &&
  data.isChild &&
  !data.subCategory &&
  (data.primarySettingsOverride || !data.parentCategory?.primarySettingsOverride)
) {
  <div class="forecast-table-grid-select-container">
    <ng-select
      [searchable]="false"
      [clearable]="true"
      [items]="componentParent.driverService.DriverOptions"
      bindLabel="label"
      bindValue="value"
      [appendTo]="'body'"
      [ngModel]="data.driver"
      [placeholder]="
        (data.parentCategory?.primarySettingsOverride && !data.primarySettingsOverride) ||
        !componentParent.userHasModifyPermissions
          ? ''
          : componentParent.checkService.formControlConstants.PLACEHOLDER.SELECT
      "
      [disabled]="
        (data.parentCategory?.primarySettingsOverride && !data.primarySettingsOverride) ||
        disableDriver ||
        componentParent.isForecastFinalized ||
        componentParent.isClosedMonthsProcessing
      "
      [auxTooltip]="
        componentParent.checkService.tooltipText(
          componentParent.isForecastFinalized || componentParent.isClosedMonthsProcessing,
          componentParent.userHasModifyPermissions
        )
      "
      [ngClass]="{
        'forecast-table-grid-select forecast-driver-select': true,
        'is-invalid':
          (componentParent.checkService.isShowError(data.primarySettingsId) | async) ||
          (componentParent.checkService.isActivityUnforecasted(data.id) | async),
      }"
      (ngModelChange)="
        componentParent.onDriverChange($event, data.fullActivity!.primary_settings, {
          name: 'activity',
          id: data.id,
        })
      "
    >
      <ng-template ng-option-tmp let-item="item">
        @if (
          {
            optionNotAvailable: (mapOptionAvailable.get(item.value) | async) === false,
          };
          as obj
        ) {
          <div
            [auxTooltip]="obj.optionNotAvailable ? getOptionAvailableTooltip(item.value) : ''"
            class="px-[10px] py-[8px]"
            [ngClass]="{
              'cursor-not-allowed opacity-60': obj.optionNotAvailable,
            }"
            (click)="obj.optionNotAvailable && $event.stopPropagation()"
          >
            <span [title]="item.label">{{ item.label }}</span>
          </div>
        }
      </ng-template>
    </ng-select>
  </div>
}
